import React from "react";
import type {VoidFunctionComponent} from "react";
import {Route, Routes } from "react-router-dom";
import {SongsPage} from "../songs/SongsPage";
import {SongDetailsPage} from "./pages/song-details/SongDetailsPage";
import {MySongsLibraryConnection} from "./modules/my-songs-library-connection/MySongsLibraryConnection";
import {SongsMobileFilterPage} from "./pages/songs-mobile-filter/SongsMobileFilterPage";
import * as Sentry from "@sentry/react";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

// In the long run, we'll probably want to move these route definitions into the main app router.
// https://github.com/remix-run/react-router/discussions/8753#:~:text=7)%20Optional%3A%20lift%20Routes%20up%20to%20single%20route%20config
export const SongsRouterPage: VoidFunctionComponent = () => {
  // Normally each <Route> has a path followed by an element.
  // That order is reversed in this file, to make it clear that several <Route>s are for the same element.

  return (
    <MySongsLibraryConnection>
      <SentryRoutes>
        {/* Song List page */}
        {/* React Router v5 definition was
          /songs/:resultsPage(home|browse|library)?/:libraryFilterSubset(favorites)? */}
        <Route element={<SongsPage/>} path={"home"} />
        <Route element={<SongsPage/>} path={"browse"} />
        {/*/song/library*/}
        {/*/song/library/favorites*/}
        <Route element={<SongsPage/>} path={"library/:libraryFilterSubset?"} />

        {/* Song Details page - must have the parameter "songId" */}
        {/* React Router v5 definition was
          /songs/:resultsPage(browse)?/:songId([0-9]*)/:lessonId([0-9]*)? */}
        <Route element={<SongDetailsPage/>} path={":songId"} />
        <Route element={<SongDetailsPage/>} path={":songId/:lessonId"} />
        <Route element={<SongDetailsPage/>} path={":resultsPage/:songId"} />
        <Route element={<SongDetailsPage/>} path={":resultsPage/:songId/:lessonId"} />
            
        {/* Song Filter page */}
        {/* React Router v5 definition was
          /songs/:resultsPage(home|browse|library)?/filter */}
        <Route element={<SongsMobileFilterPage/>} path={"browse/filter"} />
        <Route element={<SongsMobileFilterPage/>} path={"library/filter"} />

        {/* no route found, go to songs -> home */}
        <Route path={'*'} element={<SongsPage/>} />
      </SentryRoutes>
    </MySongsLibraryConnection>
  );
}
